import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Divider from '@mui/material/Divider';
import TrackListScroller from './../items/TrackListScroller';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import SearchField from './../items/SearchField';
import sessionStore from './../../stores/session';
import searchStore from './../../stores/search';
import songbookSessionStore from './../../stores/songbookSession';
import messageStore from './../../stores/message';
import accountStore from '../../stores/account';

function Search(props) {
  const itemsOnPage = 25;
  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const isWaiting = searchStore((state) => state.isWaiting);
  const totalCount = searchStore((state) => state.totalCount);
  const tracks = searchStore((state) => state.tracks);
  const searchQuery = searchStore((state) => state.searchQuery);
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const search = searchStore((state) => state.search);
  const searchMore = searchStore((state) => state.searchMore);
  const isFinished = searchStore((state) => state.isFinished);
  const fieldTitle = searchStore((state) => state.fieldTitle);
  const fieldArtist = searchStore((state) => state.fieldArtist);
  const toggleFieldTitle = searchStore((state) => state.toggleFieldTitle);
  const toggleFieldArtist = searchStore((state) => state.toggleFieldArtist);
  const setError = messageStore((state) => state.setError);
  const clearSearch = searchStore((state) => state.clearSearch);
  const setResetArtistSearchMode = searchStore((state) => state.setResetArtistSearchMode);
  const isArtistSearchMode = searchStore((state) => state.isArtistSearchMode);
  const accountLang = accountStore((state) => state.account?.language);

  useEffect(() => {}, [accountLang]);

  const ref = useRef(null);

  useEffect(() => {
    if (ref) {
      if (ref.current) {

        ref.current.value = searchQuery;
      }
    }
  }, [searchQuery]);

  let [changedSearchQuery, setChangedSearchQuery] = useState(searchQuery);

  const handleSearchQueryChange = (e) => {
    setChangedSearchQuery(e.target.value);
    if(isArtistSearchMode){
      setResetArtistSearchMode();
    }
  };

  const handleScrollDown = () => {
    searchMore(sessionToken, itemsOnPage);
  };

  const scrollToTop = () => {
    const element = document.getElementById('search-tracklist');
    if (element) {
      element.scrollTop = 0;
    }
  };

  const onSearch = () => {
    if (changedSearchQuery.length > 1) {
      setSearchQuery(changedSearchQuery);
      search(sessionToken, itemsOnPage);
      scrollToTop();
      if (document.activeElement) {
        document.activeElement.blur();
      }
    } else {
      setError(sessionToken, 0, TR.cm_seach_text_too_short);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  const handleSearch = () => {
    onSearch();
  };

  const handleFieldTitle = () => {
    console.log("search change")
    toggleFieldTitle();
  };

  const handleFieldArtist = () => {
    console.log("search change")
    toggleFieldArtist();
  };

  const createPlaceholder = () => {
    if (fieldArtist && !fieldTitle) {
      return TR.cm_song_artist_or_code;
    } else if (fieldTitle && !fieldArtist) {
      return TR.cm_song_title_or_code;
    } else {
      return TR.cm_song_title_artist_or_code;
    }
  };

  const handleSearchClear = () => {
    if (ref.current) {
      ref.current.value = "";
    }
  };

  const renderFilterBoxes = () => {
    console.log(searchStore.getState().fieldTitle, searchStore.getState().fieldArtist)
    return <p>
      <FormControlLabel onChange={handleFieldTitle} control={<Checkbox checked={fieldTitle} />} label={TR.cm_song_title} />
      <FormControlLabel onChange={handleFieldArtist} control={<Checkbox checked={fieldArtist} />} label={TR.cm_artist} />
    </p>;
  };

  const renderTotalCount = () => {
    if (tracks) {
      return <p>
        {TR.cm_total}: {totalCount}
      </p>;
    }
    return <p>&nbsp;</p>;
  };

  return (
    <div>
      <h3>{TR.cm_search} {searchQuery.length > 0 ? "- " + searchQuery : ""}</h3>
      <SearchField isSongbook={props.isSongbook} id="muvika-search-field" onref={ref} onClear={handleSearchClear} placeholder={createPlaceholder()} className={props.isSongbook ? "muvika-container-songbook-search-field" : "muvika-container-search-field"} value={searchQuery} onSearchQueryChange={handleSearchQueryChange} onSearch={handleSearch} onKeyDown={handleKeyDown} />
      {renderFilterBoxes()}
      {renderTotalCount()}
      <TrackListScroller isSongbook={props.isSongbook} isWaiting={isWaiting} id="search-tracklist" isFinished={isFinished} tracks={tracks} onScrollDown={handleScrollDown} />
    </div>
  );
}

export default Search;